module.exports = __webpack_public_path__ + "img/95.3.TP.419fabe3.png";